/**
 * Root namespace for cms modules
 * @namespace cms
 */
import './jquery-global';
import Raven from 'raven-js';
import RavenAngular from "raven-js/plugins/angular";
import angular from 'angular';
import anularGettext from 'angular-gettext';
import ngAnimate from 'angular-animate';
import angularLocalStorage from 'angular-local-storage';
import httpAuthInterceptor from 'angular-http-auth';
import xdebugInterceptor from './../../cmsCore/Xdebug/xdebugInterceptor';
import loaderInterceptor from './../../cmsCore/Loader/LoaderInterceptor';
import responseInterceptor from '../../cmsCore/Auth/ResponseInterceptor';

import '../sass/main.scss'

import './angular-legacy-modules';
import './non-angular-vendors'

import BlurAdminTheme from '../../cmsCore/BlurAdmin/blur-admin-theme'
import cmsConfig from './cmsConfig';
import cmsRun from './cmsRun';

import MsgCenter from '../../cmsCore/MessageCenter/msgCenter.directive';

import DashboardPage from '../../cmsPages/Dashboard/Dashboard';
import LogsPage from '../../cmsPages/Logs/Logs';
import UsersPage from '../../cmsPages/Users/Users';
import ProductsPage from '../../cmsPages/Products/ProductsPageModule';
import MediaModule from '../../cmsPages/Media/MediaPageModule';
import MailsPage from '../../cmsPages/Mails/MailsPageModule';
import PagesPage from '../../cmsPages/Pages/PagesPageModule';

import cmsAuth from '../../cmsCore/Auth/CMSAuthService';
import cmsAuthDialog from '../../cmsCore/Auth/AuthDialogService';
import cmsLanguageManager from '../../cmsCore/Language/LanguageManager';
import cmsLoader from '../../cmsCore/Loader/LoaderDirective';
import cmsPageTitle from '../../cmsCore/PageTitle/TitlePageDirective';
import cmsPageClass from '../../cmsCore/PageClass/PageClassDirective';
import cmsOnLoad from '../../cmsCore/OnLoadDirective/OnLoadDirective';
import cmsACL from '../../cmsCore/ACL/ACLService';

import exportService from '../../cmsCore/Export/ExportService';
import exportMailTemplateService from '../../cmsPages/Mails/Services/ExportMailTemplateService';
import exportPageTemplateService from '../../cmsPages/Pages/Services/ExportPageTemplateService';

import appConfig from '../../cmsCore/ConfigModule/ConfigModule';

import cmsInputText from '../../cmsCore/Controls/TextControl/CmsInputText';
import cmsInputVideo from '../../cmsCore/Controls/VideoControl/CmsInputVideo';
import cmsFontSelect from '../../cmsCore/Controls/FontSelectControl/CmsFontSelect';
import cmsInputTextarea from '../../cmsCore/Controls/TextareaControl/CmsInputTextarea';
import cmsInputSlug from '../../cmsCore/Controls/SlugControl/CmsInputSlug';
import cmsInputMoney from '../../cmsCore/Controls/MoneyControl/CmsInputMoney';
import cmsInputNumber from '../../cmsCore/Controls/NumberControl/CmsInputNumber';
import cmsInputPassword from '../../cmsCore/Controls/PasswordControl/CmsInputPassword'
import cmsInputEmail from '../../cmsCore/Controls/EmailControl/CmsInputEmail'
import cmsInputCheckbox from '../../cmsCore/Controls/ChckboxControl/CmsInputCheckbox'
import cmsInputSelect from '../../cmsCore/Controls/SelectControl/CmsInputSelect'
import cmsInputObjectSelect from '../../cmsCore/Controls/ObjectSelectControl/CmsInputObjectSelect'
import CmsInputSelectionButtons from '../../cmsCore/Controls/AlignControl/CmsInputAlign';
import cmsInputAlign from '../../cmsCore/Controls/SelectionButtonsControl/CmsInputSelectionButtons';
import cmsInputDate from '../../cmsCore/Controls/DateControl/CmsInputDate'
import cmsInputMedia from '../../cmsCore/Controls/MediaControl/CmsInputMedia'
import cmsInputColor from '../../cmsCore/Controls/ColorControl/CmsInputColor';
import cmsInputHtmlEditor from '../../cmsCore/Controls/HtmlEditorControl/CmsInputHtmlEditor';
import cmsInputOptions from '../../cmsCore/Controls/OptionsControl/CmsInputOptions';
import cmsInputEditForm from '../../cmsCore/Controls/EditFormControl/CmsEditForm';
import cmsInputColumns from '../../cmsCore/Controls/ColumnsControl/CmsInputColumns';
import cmsInputMenu from '../../cmsCore/Controls/MenuControl/CmsInputMenu';
import cmsInputButtonLink from '../../cmsCore/Controls/ButtonLinkControl/CmsButtonLink';
import cmsInputMapAddress from '../../cmsCore/Controls/MapAddressControl/CmsInputMapAddress';
import hasMediaTile from '../../cmsCore/MediaModules/HasMediaTile/HasMediaTile';
import selectMedia from '../../cmsCore/MediaModules/SelectMedia/SelectMedia';
import changePassword from '../../cmsCore/ChangePasswordModal/changePassword';
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';
import uniqueIdGenerator from '../../cmsCore/UniqueIdGenerator/UniqueIdGenerator';
import saveWarningDialog from '../../cmsCore/SaveWarning/saveWarningDialog';
import saveWarningIntervalDialog from '../../cmsCore/SaveWarning/saveWarningIntervalDialog';
import addPageDialog from '../../cmsPages/Pages/Services/AddPageDialog';
import exportAsTemplateDialog from '../../cmsPages/Pages/Services/ExportAsTemplateDialog';

import creatorWorkspace from '../../cmsCore/Creator/Workspace/Workspace';
import creatorToolbar from '../../cmsCore/Creator/Toolbar/Toolbar';
import creatorSectionsLibrary from '../../cmsCore/Creator/SectionsLibrary/SectionsLibrary';

import creatorMailSectionText from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/Text/Text';
import creatorMailSectionDivider from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/Divider/Divider';
import creatorMailSectionImage from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/Image/Image';
import creatorMailSectionSocial from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/Social/Social';
import creatorMailSectionButton from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/Button/Button';
import creatorMailSectionImageText from '../../cmsCore/Creator/SectionsLibrary/Sections/Mail/ImageText/ImageText';

import editorTextarea from '../../cmsCore/RichTextEditor/EditorTextarea/EditorTextarea';
import editorInline from '../../cmsCore/RichTextEditor/EditorInline/EditorInline';

import creatorPageSectionText from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Text/Text';
import creatorPageSectionHtml from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Html/Html';
import creatorPageSectionDivider from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Divider/Divider';
import creatorPageSectionImage from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Image/Image';
import creatorPageSectionSocial from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Social/Social';
import creatorPageSectionButton from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Button/Button';
import creatorPageSectionForm from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Form/Form';
import creatorPageSection from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Section/Section';
import creatorPageSectionMenu from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Menu/Menu';
import creatorPageSectionMap from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Map/Map';
import creatorPageSectionVideo from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/Video/Video';
import creatorPageSectionFacebookFeed from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/FacebookFeed/FacebookFeed';
import creatorPageSectionTwitterFeed from '../../cmsCore/Creator/SectionsLibrary/Sections/Page/TwitterFeed/TwitterFeed';
import creatorFormEditor from '../../cmsCore/Creator/FormEditor/FormEditor';

import logsFeed from '../../cmsPages/Dashboard/logFeed/LogFeed';
import SaveWarning from '../../cmsCore/SaveWarning/SaveWarning';

import imageUrl from '../../cmsCore/MediaModules/ImageUrlFilter';
import mediaPlaceholder from '../../cmsCore/MediaModules/MediaPlaceholder/MediaPlaceholder';
import trust from '../../cmsCore/HtmlTrustedFilter/HtmlTrustedFilter';
import numberWithUnit from '../../cmsCore/NumberWithUnitFilter/NumberWithUnitFilter';

import scrollLockDirective from '../../cmsCore/Creator/ScrollLock/ScrollLockDirective';

// charts
import pieChart from '../../cmsCore/Chart/PieChart/pieChart';
import linearChart from '../../cmsCore/Chart/LinearChart/linearChart';


Raven.config('https://af42a9f9864b42f7902469e8388b8ac8@sentry.cdwv.pl/77',{
    shouldSendCallback: function () {
        return !APP_CONFIG.DEV
  }}).addPlugin(RavenAngular, angular)
  .install();


/**
 * Main module for our cms. Most of the time this will be entry point for the angular application.
 * Currently Main module is responsible for "global" configuration and for loading main pages and dependencies.
 *
 * @namespace cms.MainModule
 */
let MainModule = angular.module('cms', [
    DashboardPage,
    SaveWarning,
    LogsPage,
    MediaModule,
    UsersPage,
    MailsPage,
    ProductsPage,
    PagesPage,
    ngAnimate,
    angularLocalStorage,
    appConfig,
    cmsAuth,
    cmsLanguageManager,
    cmsAuthDialog,
    cmsLoader,
    exportService,
    exportMailTemplateService,
    exportPageTemplateService,
    httpAuthInterceptor,
    xdebugInterceptor,
    loaderInterceptor,
    responseInterceptor,
    BlurAdminTheme,
    MsgCenter,
    anularGettext,
    editorTextarea,
    editorInline,
    cmsFontSelect,
    cmsInputText,
    cmsInputTextarea,
    cmsInputSlug,
    cmsInputMoney,
    cmsInputNumber,
    cmsInputPassword,
    cmsInputEmail,
    cmsInputCheckbox,
    cmsInputSelect,
    cmsInputObjectSelect,
    cmsInputAlign,
    cmsInputVideo,
    CmsInputSelectionButtons,
    cmsInputDate,
    cmsInputMedia,
    cmsInputHtmlEditor,
    cmsInputColor,
    cmsInputOptions,
    cmsInputEditForm,
    cmsInputColumns,
    cmsInputMenu,
    cmsInputButtonLink,
    cmsInputMapAddress,
    changePassword,
    hasMediaTile,
    deleteElementDialog,
    uniqueIdGenerator,
    saveWarningDialog,
    saveWarningIntervalDialog,
    addPageDialog,
    exportAsTemplateDialog,
    selectMedia,
    cmsPageTitle,
    cmsPageClass,
    cmsACL,
    creatorWorkspace,
    creatorToolbar,
    creatorSectionsLibrary,
    creatorMailSectionText,
    creatorMailSectionDivider,
    creatorMailSectionImage,
    creatorMailSectionSocial,
    creatorMailSectionButton,
    creatorMailSectionImageText,
    creatorPageSectionText,
    creatorPageSectionDivider,
    creatorPageSectionImage,
    creatorPageSectionSocial,
    creatorPageSectionButton,
    creatorPageSectionForm,
    creatorPageSection,
    creatorPageSectionMenu,
    creatorPageSectionHtml,
    creatorPageSectionMap,
    creatorPageSectionVideo,
    creatorPageSectionFacebookFeed,
    creatorPageSectionTwitterFeed,
    creatorFormEditor,
    cmsOnLoad,
    imageUrl,
    mediaPlaceholder,
    trust,
    numberWithUnit,
    logsFeed,
    scrollLockDirective,
    pieChart,
    linearChart,
    RavenAngular.moduleName
])
    .config(cmsConfig)
    .run(cmsRun);

export default MainModule.name;




// WEBPACK FOOTER //
// ./src/mainModule/js/main.js